import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountMigrationLoginPage } from './pages/account-migration-login/account-migration-login.page';
import { SharedModule } from '../shared/shared.module';
import { AccountMigrationLoginComponent } from './organisms/account-migration-login/account-migration-login.component';
import { AccountMigrationRoutingModule } from './account-migration-routing.module';
import { TranslocoModule } from '@ngneat/transloco';
import { FinishAccountPage } from './pages/finish-account/finish-account.page';
import { FinishAccountComponent } from './organisms/finish-account/finish-account.component';
import { ConfirmDataPage } from './pages/confirm-data/confirm-data.page';
import { ConfirmDataComponent } from './organisms/confirm-data/confirm-data.component';
import { OnboardingPage } from './pages/onboarding/onboarding.page';
import { MigrationOnboardingComponent } from './organisms/migration-onboarding/migration-onboarding.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AccountMigrationLoginPage,
    AccountMigrationLoginComponent,
    FinishAccountPage,
    FinishAccountComponent,
    ConfirmDataPage,
    ConfirmDataComponent,
    OnboardingPage,
    MigrationOnboardingComponent,
  ],
  imports: [
    AccountMigrationRoutingModule,
    CommonModule,
    SharedModule,
    TranslocoModule,
    ReactiveFormsModule,
  ],
})
/**
 * Account migration module
 */
export class AccountMigrationModule {}
